import { useState, useCallback, useMemo } from "react";
import ContractStep from "./ContractStep";
import CarStep from "./CarStep";
import { useSelector } from "react-redux";
import { cartransferSelector } from "../../../features/cartransferSlice";
import { useUpdateCartransfer } from "../../../hooks/useUpdateCartransfer";
import { Row, Col } from "antd";

const FinalStep = () => {
  //this needs to be put in the DB in case we do multi tenant
  const notary = useMemo(() => ({
    names: "JUAN CARLOS",
    firstLastName: "CABEZAS",
    secondLastName: "CEPEDA",
    address: "AVENIDA PRESIDENTE IBAÑEZ 280",
    commune: "PUERTO MONTT",
    phone: "722695700",
    rut: "13756524",
    dv: "2",
    fullRut: "13.756.524-2",
  }), []);
  const [buttons, setButtons] = useState({});
  const finalData = useSelector(cartransferSelector);
  const id = useSelector((state) => state.cartransfer.id);
  const updateCartransfer = useUpdateCartransfer();

  // Eliminado el auto-guardado automático para evitar bucles infinitos
  // Los datos se guardarán solo cuando el usuario haga clic en "Descargar archivos"

  const handleFinish = useCallback(async () => {
    try {
      const response = await updateCartransfer.mutateAsync({
        id,
        data: {
          ...finalData,
          contract: {
            ...finalData.contract,
            repertory: `${finalData.repertory}-${finalData.repertoryYear}`,
          },
          notary,
        },
      });
      setButtons({
        pdf: response.data.pdfUrl,
        word: response.data.docUrl,
        pdfCopy: response.data.pdfUrlCopy,
      });
      //shitty patch needs to be refactored
      // TODO: Migrar esto a un hook de Redux o manejar de otra forma
    } catch (error) {
      console.error(error);
    }
  }, [id, finalData, updateCartransfer, notary]);
  return (
    <Row gutter={[16, 16]}>
      <Col span={8} l={8} xl={8} xs={24} s={24}>
        <CarStep
          handleFinish={handleFinish}
          loading={updateCartransfer.isPending}
          notary={notary}
          buttons={buttons}
          label="Confirmar datos"
        />
      </Col>
      <Col span={16} l={16} xl={16} xs={24} s={24}>
        <ContractStep label="Previsualización" />
      </Col>
    </Row>
  );
};

export default FinalStep;
